import { CategoryAggregation } from '@cartwhl/common/types';

export const DEFAULT_BROWSE_CATEGORIES: CategoryAggregation[] = [
  {
    category: 'action and adventure',
    doc_count: 7384,
    subcategories: [
      {
        subcategory: 'featured',
        doc_count: 58,
        tags: [],
      },
      {
        subcategory: 'animal movements',
        doc_count: 67,
        tags: [],
      },
      {
        subcategory: 'catch',
        doc_count: 93,
        tags: [
          {
            tag: '2 handed',
            doc_count: 47,
          },
          {
            tag: 'grab',
            doc_count: 26,
          },
          {
            tag: 'heavy catch',
            doc_count: 3,
          },
          {
            tag: 'dramatic catch',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'chase',
        doc_count: 88,
        tags: [
          {
            tag: 'flee',
            doc_count: 29,
          },
          {
            tag: 'pursue',
            doc_count: 21,
          },
        ],
      },
      {
        subcategory: 'climb',
        doc_count: 89,
        tags: [
          {
            tag: 'ladder',
            doc_count: 16,
          },
          {
            tag: 'wall climb',
            doc_count: 9,
          },
          {
            tag: 'descend',
            doc_count: 13,
          },
          {
            tag: 'rope climb',
            doc_count: 4,
          },
          {
            tag: 'ledge',
            doc_count: 8,
          },
          {
            tag: 'rock climb',
            doc_count: 8,
          },
          {
            tag: 'repel',
            doc_count: 2,
          },
          {
            tag: 'belay',
            doc_count: 1,
          },
          {
            tag: 'look behind',
            doc_count: 1,
          },
          {
            tag: 'window climb',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'explore',
        doc_count: 20,
        tags: [
          {
            tag: 'search',
            doc_count: 7,
          },
          {
            tag: 'investigate',
            doc_count: 4,
          },
        ],
      },
      {
        subcategory: 'flips',
        doc_count: 306,
        tags: [
          {
            tag: 'spin',
            doc_count: 29,
          },
          {
            tag: '360',
            doc_count: 11,
          },
          {
            tag: 'backflip',
            doc_count: 26,
          },
          {
            tag: 'frontflip',
            doc_count: 21,
          },
          {
            tag: '180',
            doc_count: 3,
          },
          {
            tag: 'side flip',
            doc_count: 17,
          },
          {
            tag: 'double',
            doc_count: 8,
          },
          {
            tag: 'right',
            doc_count: 5,
          },
          {
            tag: 'left',
            doc_count: 9,
          },
          {
            tag: 'triple',
            doc_count: 2,
          },
          {
            tag: 'dive',
            doc_count: 3,
          },
          {
            tag: 'failed',
            doc_count: 3,
          },
        ],
      },
      {
        subcategory: 'gymnastics',
        doc_count: 606,
        tags: [
          {
            tag: 'jump',
            doc_count: 149,
          },
          {
            tag: 'balance',
            doc_count: 76,
          },
          {
            tag: 'lower body moves',
            doc_count: 53,
          },
          {
            tag: 'cartwheel',
            doc_count: 63,
          },
          {
            tag: 'twists and spins',
            doc_count: 24,
          },
          {
            tag: 'stretch',
            doc_count: 28,
          },
          {
            tag: 'upper body moves',
            doc_count: 39,
          },
          {
            tag: 'swing',
            doc_count: 9,
          },
          {
            tag: 'poses',
            doc_count: 27,
          },
          {
            tag: 'bend',
            doc_count: 19,
          },
          {
            tag: 'flips',
            doc_count: 25,
          },
          {
            tag: 'handstand',
            doc_count: 22,
          },
          {
            tag: 'somersault',
            doc_count: 7,
          },
          {
            tag: 'forward',
            doc_count: 13,
          },
          {
            tag: 'backward',
            doc_count: 11,
          },
          {
            tag: 'roll',
            doc_count: 8,
          },
          {
            tag: 'fails',
            doc_count: 7,
          },
          {
            tag: 'handspring',
            doc_count: 8,
          },
          {
            tag: 'side',
            doc_count: 4,
          },
          {
            tag: 'aerial',
            doc_count: 4,
          },
          {
            tag: 'scorpion',
            doc_count: 2,
          },
          {
            tag: 'bars and rings',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'heroic',
        doc_count: 190,
        tags: [
          {
            tag: 'power pose',
            doc_count: 83,
          },
          {
            tag: 'superhero landing',
            doc_count: 20,
          },
          {
            tag: 'protect',
            doc_count: 4,
          },
          {
            tag: 'rescue',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'jump',
        doc_count: 1573,
        tags: [
          {
            tag: 'forward',
            doc_count: 226,
          },
          {
            tag: 'hop',
            doc_count: 253,
          },
          {
            tag: 'backward',
            doc_count: 164,
          },
          {
            tag: 'spin',
            doc_count: 47,
          },
          {
            tag: 'side jump',
            doc_count: 118,
          },
          {
            tag: 'long jump',
            doc_count: 125,
          },
          {
            tag: 'bounce',
            doc_count: 113,
          },
          {
            tag: 'jumping jacks',
            doc_count: 70,
          },
          {
            tag: 'high jump',
            doc_count: 73,
          },
          {
            tag: '360',
            doc_count: 23,
          },
          {
            tag: 'super jump',
            doc_count: 40,
          },
          {
            tag: 'squat jump',
            doc_count: 45,
          },
          {
            tag: 'dive',
            doc_count: 21,
          },
          {
            tag: '1 leg',
            doc_count: 39,
          },
          {
            tag: '180',
            doc_count: 16,
          },
          {
            tag: 'hurdle',
            doc_count: 19,
          },
          {
            tag: '90',
            doc_count: 7,
          },
          {
            tag: 'bound',
            doc_count: 9,
          },
          {
            tag: 'flip',
            doc_count: 13,
          },
          {
            tag: 'awkward',
            doc_count: 10,
          },
          {
            tag: '270',
            doc_count: 3,
          },
          {
            tag: 'heel click',
            doc_count: 8,
          },
          {
            tag: 'ledge jump',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'landings and falls',
        doc_count: 1194,
        tags: [
          {
            tag: 'controlled',
            doc_count: 228,
          },
          {
            tag: 'backward',
            doc_count: 154,
          },
          {
            tag: 'absorb impact',
            doc_count: 135,
          },
          {
            tag: 'painful',
            doc_count: 129,
          },
          {
            tag: 'fall on back',
            doc_count: 108,
          },
          {
            tag: 'stumble',
            doc_count: 95,
          },
          {
            tag: 'crash',
            doc_count: 72,
          },
          {
            tag: 'ground slam',
            doc_count: 46,
          },
          {
            tag: 'soft landing',
            doc_count: 60,
          },
          {
            tag: 'faceplant',
            doc_count: 69,
          },
          {
            tag: 'forward',
            doc_count: 56,
          },
          {
            tag: 'hero landing',
            doc_count: 45,
          },
          {
            tag: 'fall onto knees',
            doc_count: 52,
          },
          {
            tag: 'bounce',
            doc_count: 37,
          },
          {
            tag: 'trip',
            doc_count: 25,
          },
          {
            tag: 'ragdoll',
            doc_count: 21,
          },
          {
            tag: 'tuck and roll',
            doc_count: 18,
          },
          {
            tag: 'fall on butt',
            doc_count: 16,
          },
          {
            tag: 'knocked down',
            doc_count: 13,
          },
          {
            tag: 'bellyflop',
            doc_count: 10,
          },
          {
            tag: 'cliff',
            doc_count: 1,
          },
          {
            tag: 'slip',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'slide',
        doc_count: 108,
        tags: [
          {
            tag: 'backwards',
            doc_count: 26,
          },
          {
            tag: 'forwards',
            doc_count: 13,
          },
          {
            tag: 'scoot',
            doc_count: 5,
          },
          {
            tag: 'baseball slide',
            doc_count: 5,
          },
          {
            tag: 'knee slide',
            doc_count: 2,
          },
          {
            tag: 'ice slide',
            doc_count: 2,
          },
          {
            tag: 'slide tackle',
            doc_count: 1,
          },
          {
            tag: 'belly slide',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'stealth',
        doc_count: 232,
        tags: [
          {
            tag: 'cautious',
            doc_count: 67,
          },
          {
            tag: 'retreat',
            doc_count: 55,
          },
          {
            tag: 'sneak run',
            doc_count: 40,
          },
          {
            tag: 'take cover',
            doc_count: 15,
          },
          {
            tag: 'backwards',
            doc_count: 21,
          },
          {
            tag: 'look around',
            doc_count: 20,
          },
          {
            tag: 'hide',
            doc_count: 15,
          },
          {
            tag: 'peek',
            doc_count: 15,
          },
          {
            tag: 'forwards',
            doc_count: 19,
          },
          {
            tag: 'crawl',
            doc_count: 8,
          },
          {
            tag: 'cower',
            doc_count: 4,
          },
          {
            tag: 'steal',
            doc_count: 1,
          },
          {
            tag: 'sneak slide',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'stunts and parkour',
        doc_count: 395,
        tags: [
          {
            tag: 'spin',
            doc_count: 25,
          },
          {
            tag: 'jump',
            doc_count: 41,
          },
          {
            tag: 'charge',
            doc_count: 34,
          },
          {
            tag: 'roll',
            doc_count: 38,
          },
          {
            tag: 'dive',
            doc_count: 26,
          },
          {
            tag: 'tumble',
            doc_count: 21,
          },
          {
            tag: '360',
            doc_count: 4,
          },
          {
            tag: 'dash',
            doc_count: 8,
          },
          {
            tag: 'aerial',
            doc_count: 6,
          },
          {
            tag: 'fall',
            doc_count: 6,
          },
          {
            tag: 'break wall',
            doc_count: 5,
          },
          {
            tag: 'crash',
            doc_count: 2,
          },
          {
            tag: 'balance',
            doc_count: 5,
          },
          {
            tag: 'tuck and roll',
            doc_count: 1,
          },
          {
            tag: 'rope swing',
            doc_count: 1,
          },
          {
            tag: 'barrel roll',
            doc_count: 1,
          },
          {
            tag: 'head slam',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'throw',
        doc_count: 756,
        tags: [
          {
            tag: 'overhand',
            doc_count: 406,
          },
          {
            tag: '1 hand',
            doc_count: 280,
          },
          {
            tag: 'wind up',
            doc_count: 149,
          },
          {
            tag: '2 hands',
            doc_count: 106,
          },
          {
            tag: 'downward',
            doc_count: 93,
          },
          {
            tag: 'upward',
            doc_count: 61,
          },
          {
            tag: 'sidearm',
            doc_count: 68,
          },
          {
            tag: 'cross body',
            doc_count: 57,
          },
          {
            tag: 'fast',
            doc_count: 46,
          },
          {
            tag: 'baseball throw',
            doc_count: 60,
          },
          {
            tag: 'frisbee throw',
            doc_count: 27,
          },
          {
            tag: 'underhand',
            doc_count: 38,
          },
          {
            tag: 'awkward',
            doc_count: 20,
          },
          {
            tag: 'pitch',
            doc_count: 13,
          },
          {
            tag: 'javelin throw',
            doc_count: 8,
          },
          {
            tag: 'skip rock',
            doc_count: 7,
          },
          {
            tag: 'seated',
            doc_count: 2,
          },
          {
            tag: 'dice roll',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'vault',
        doc_count: 8,
        tags: [
          {
            tag: 'obstacle vault',
            doc_count: 1,
          },
        ],
      },
    ],
  },
  {
    category: 'character interaction',
    doc_count: 784,
    subcategories: [
      {
        subcategory: 'featured',
        doc_count: 28,
        tags: [],
      },
      {
        subcategory: 'conversation',
        doc_count: 93,
        tags: [
          {
            tag: 'arm movement',
            doc_count: 33,
          },
          {
            tag: 'casual gesture',
            doc_count: 24,
          },
          {
            tag: 'body sway',
            doc_count: 15,
          },
          {
            tag: 'head movement',
            doc_count: 11,
          },
          {
            tag: 'lean',
            doc_count: 2,
          },
          {
            tag: 'point',
            doc_count: 4,
          },
          {
            tag: 'sign language',
            doc_count: 3,
          },
          {
            tag: 'eye contact',
            doc_count: 1,
          },
          {
            tag: 'whisper',
            doc_count: 1,
          },
          {
            tag: 'look down',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'gestures and greetings',
        doc_count: 482,
        tags: [
          {
            tag: 'interactive',
            doc_count: 9,
          },
          {
            tag: 'wave',
            doc_count: 96,
          },
          {
            tag: 'hand signal',
            doc_count: 14,
          },
          {
            tag: 'handshake',
            doc_count: 61,
          },
          {
            tag: 'greet',
            doc_count: 48,
          },
          {
            tag: 'point',
            doc_count: 22,
          },
          {
            tag: 'bow',
            doc_count: 17,
          },
          {
            tag: 'beckon',
            doc_count: 13,
          },
          {
            tag: 'high five',
            doc_count: 10,
          },
          {
            tag: 'hug',
            doc_count: 10,
          },
          {
            tag: 'goodbye',
            doc_count: 7,
          },
          {
            tag: 'offer arm',
            doc_count: 5,
          },
          {
            tag: 'pet',
            doc_count: 4,
          },
          {
            tag: 'beg',
            doc_count: 1,
          },
          {
            tag: 'salute',
            doc_count: 4,
          },
          {
            tag: 'clap',
            doc_count: 3,
          },
          {
            tag: 'back pat',
            doc_count: 2,
          },
          {
            tag: 'intimidate',
            doc_count: 1,
          },
          {
            tag: 'direct traffic',
            doc_count: 2,
          },
          {
            tag: 'taunt',
            doc_count: 1,
          },
          {
            tag: 'propose',
            doc_count: 2,
          },
          {
            tag: 'playful hit',
            doc_count: 1,
          },
          {
            tag: 'fist bump',
            doc_count: 2,
          },
          {
            tag: 'kiss',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'phone interaction',
        doc_count: 62,
        tags: [
          {
            tag: 'answer call',
            doc_count: 48,
          },
          {
            tag: 'listen',
            doc_count: 38,
          },
          {
            tag: 'hang up',
            doc_count: 8,
          },
          {
            tag: 'start call',
            doc_count: 4,
          },
          {
            tag: 'texting',
            doc_count: 1,
          },
          {
            tag: 'walkie talkie',
            doc_count: 2,
          },
          {
            tag: 'pace',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'presentation',
        doc_count: 119,
        tags: [
          {
            tag: 'gesture',
            doc_count: 33,
          },
          {
            tag: 'speech',
            doc_count: 22,
          },
          {
            tag: 'explain',
            doc_count: 20,
          },
          {
            tag: 'address audience',
            doc_count: 15,
          },
          {
            tag: 'present',
            doc_count: 8,
          },
          {
            tag: 'point',
            doc_count: 4,
          },
          {
            tag: 'bow',
            doc_count: 4,
          },
          {
            tag: 'unveil',
            doc_count: 1,
          },
        ],
      },
    ],
  },
  {
    category: 'characters',
    doc_count: 105,
    subcategories: [
      {
        subcategory: 'featured',
        doc_count: 11,
        tags: [],
      },
      {
        subcategory: 'animals',
        doc_count: 30,
        tags: [
          {
            tag: 'gorilla',
            doc_count: 7,
          },
          {
            tag: 'dinosaur',
            doc_count: 2,
          },
          {
            tag: 'monkey',
            doc_count: 2,
          },
          {
            tag: 'chicken',
            doc_count: 2,
          },
          {
            tag: 'bird',
            doc_count: 1,
          },
          {
            tag: 'elephant',
            doc_count: 1,
          },
          {
            tag: 'bear',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'childlike and elderly',
        doc_count: 2,
        tags: [],
      },
      {
        subcategory: 'fantasy',
        doc_count: 3,
        tags: [
          {
            tag: 'elf',
            doc_count: 2,
          },
          {
            tag: 'goblin',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'horror',
        doc_count: 23,
        tags: [
          {
            tag: 'zombie',
            doc_count: 11,
          },
          {
            tag: 'monster',
            doc_count: 3,
          },
        ],
      },
      {
        subcategory: 'knights and warriors',
        doc_count: 15,
        tags: [
          {
            tag: 'soldier',
            doc_count: 4,
          },
          {
            tag: 'warrior',
            doc_count: 4,
          },
          {
            tag: 'guard',
            doc_count: 4,
          },
          {
            tag: 'knight',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'media characters',
        doc_count: 5,
        tags: [
          {
            tag: 'spiderman',
            doc_count: 2,
          },
          {
            tag: 'harry potter',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'ninja',
        doc_count: 4,
        tags: [
          {
            tag: 'ninja',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'occupations',
        doc_count: 6,
        tags: [
          {
            tag: 'soldier',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'sci fi',
        doc_count: 1,
        tags: [],
      },
      {
        subcategory: 'villain',
        doc_count: 5,
        tags: [
          {
            tag: 'menacing',
            doc_count: 2,
          },
          {
            tag: 'creepy',
            doc_count: 2,
          },
          {
            tag: 'evil stance',
            doc_count: 1,
          },
        ],
      },
    ],
  },
  {
    category: 'combat',
    doc_count: 5315,
    subcategories: [
      {
        subcategory: 'featured',
        doc_count: 28,
        tags: [],
      },
      {
        subcategory: 'combat presence',
        doc_count: 296,
        tags: [
          {
            tag: 'ready pose',
            doc_count: 131,
          },
          {
            tag: 'defense pose',
            doc_count: 43,
          },
          {
            tag: 'ready weapon',
            doc_count: 20,
          },
          {
            tag: 'intimidate',
            doc_count: 30,
          },
          {
            tag: 'charge',
            doc_count: 5,
          },
          {
            tag: 'advance',
            doc_count: 4,
          },
          {
            tag: 'draw weapon',
            doc_count: 5,
          },
          {
            tag: 'bow',
            doc_count: 11,
          },
          {
            tag: 'taunt',
            doc_count: 4,
          },
          {
            tag: 'battle cry',
            doc_count: 2,
          },
          {
            tag: 'glove tap',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'death',
        doc_count: 48,
        tags: [
          {
            tag: 'collapse',
            doc_count: 28,
          },
          {
            tag: 'backward',
            doc_count: 18,
          },
          {
            tag: 'chest wound',
            doc_count: 18,
          },
          {
            tag: 'gunshot',
            doc_count: 16,
          },
          {
            tag: 'face down',
            doc_count: 14,
          },
          {
            tag: 'stomach wound',
            doc_count: 14,
          },
          {
            tag: 'dramatic',
            doc_count: 11,
          },
          {
            tag: 'forward',
            doc_count: 9,
          },
          {
            tag: 'stab',
            doc_count: 5,
          },
          {
            tag: 'head wound',
            doc_count: 3,
          },
          {
            tag: 'arm wound',
            doc_count: 3,
          },
          {
            tag: 'clutch wound',
            doc_count: 3,
          },
          {
            tag: 'projectile',
            doc_count: 2,
          },
          {
            tag: 'kneel',
            doc_count: 2,
          },
          {
            tag: 'leg wound',
            doc_count: 1,
          },
          {
            tag: 'reach out',
            doc_count: 2,
          },
          {
            tag: 'beg',
            doc_count: 2,
          },
          {
            tag: 'hunched over',
            doc_count: 1,
          },
          {
            tag: 'executed',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'dodge',
        doc_count: 181,
        tags: [
          {
            tag: 'sidestep',
            doc_count: 119,
          },
          {
            tag: 'backstep',
            doc_count: 50,
          },
          {
            tag: 'bob and weave',
            doc_count: 28,
          },
          {
            tag: 'lean',
            doc_count: 31,
          },
          {
            tag: 'duck',
            doc_count: 22,
          },
          {
            tag: 'spin',
            doc_count: 11,
          },
          {
            tag: 'jump',
            doc_count: 21,
          },
          {
            tag: 'retreat',
            doc_count: 16,
          },
          {
            tag: 'backward',
            doc_count: 22,
          },
          {
            tag: 'side',
            doc_count: 3,
          },
          {
            tag: 'frontstep',
            doc_count: 2,
          },
          {
            tag: 'roll',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'impact reaction',
        doc_count: 371,
        tags: [
          {
            tag: 'stumble',
            doc_count: 215,
          },
          {
            tag: 'stagger',
            doc_count: 137,
          },
          {
            tag: 'fall',
            doc_count: 97,
          },
          {
            tag: 'head jerk',
            doc_count: 103,
          },
          {
            tag: 'backward',
            doc_count: 43,
          },
          {
            tag: 'protect head',
            doc_count: 39,
          },
          {
            tag: 'bend over',
            doc_count: 21,
          },
          {
            tag: 'absorb punch',
            doc_count: 20,
          },
          {
            tag: 'flinch',
            doc_count: 16,
          },
          {
            tag: 'arm defense',
            doc_count: 14,
          },
          {
            tag: 'recover',
            doc_count: 15,
          },
          {
            tag: 'buckle',
            doc_count: 9,
          },
          {
            tag: 'shake it off',
            doc_count: 8,
          },
          {
            tag: 'injury',
            doc_count: 8,
          },
          {
            tag: 'block',
            doc_count: 6,
          },
          {
            tag: 'forward',
            doc_count: 9,
          },
          {
            tag: 'side',
            doc_count: 7,
          },
          {
            tag: 'fall down',
            doc_count: 5,
          },
          {
            tag: 'choke',
            doc_count: 3,
          },
        ],
      },
      {
        subcategory: 'kicking',
        doc_count: 415,
        tags: [
          {
            tag: 'side kick',
            doc_count: 125,
          },
          {
            tag: 'right',
            doc_count: 130,
          },
          {
            tag: 'front kick',
            doc_count: 132,
          },
          {
            tag: 'left',
            doc_count: 111,
          },
          {
            tag: 'high kick',
            doc_count: 92,
          },
          {
            tag: 'spin',
            doc_count: 37,
          },
          {
            tag: 'double',
            doc_count: 51,
          },
          {
            tag: 'combo',
            doc_count: 36,
          },
          {
            tag: 'karate kick',
            doc_count: 35,
          },
          {
            tag: 'high',
            doc_count: 33,
          },
          {
            tag: 'roundhouse',
            doc_count: 19,
          },
          {
            tag: 'jump',
            doc_count: 15,
          },
          {
            tag: 'quick',
            doc_count: 20,
          },
          {
            tag: 'leg sweep',
            doc_count: 7,
          },
          {
            tag: 'triple',
            doc_count: 17,
          },
          {
            tag: '360',
            doc_count: 11,
          },
          {
            tag: 'aerial',
            doc_count: 6,
          },
          {
            tag: 'heel kick',
            doc_count: 4,
          },
          {
            tag: 'ground kick',
            doc_count: 2,
          },
          {
            tag: 'knee',
            doc_count: 2,
          },
          {
            tag: 'sparta kick',
            doc_count: 1,
          },
          {
            tag: 'awkward',
            doc_count: 2,
          },
          {
            tag: 'fake kick',
            doc_count: 2,
          },
          {
            tag: 'cross kick',
            doc_count: 2,
          },
          {
            tag: 'crescent kick',
            doc_count: 2,
          },
          {
            tag: 'axe kick',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'killing blow',
        doc_count: 54,
        tags: [
          {
            tag: 'stab',
            doc_count: 27,
          },
          {
            tag: 'slice',
            doc_count: 9,
          },
          {
            tag: 'slam',
            doc_count: 3,
          },
          {
            tag: 'smash',
            doc_count: 4,
          },
          {
            tag: 'decapitate',
            doc_count: 3,
          },
          {
            tag: 'headbutt',
            doc_count: 1,
          },
          {
            tag: 'throw',
            doc_count: 1,
          },
          {
            tag: 'sneak attack',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'punch',
        doc_count: 869,
        tags: [
          {
            tag: 'left',
            doc_count: 489,
          },
          {
            tag: 'right',
            doc_count: 224,
          },
          {
            tag: 'jab',
            doc_count: 254,
          },
          {
            tag: 'hook',
            doc_count: 126,
          },
          {
            tag: 'wind up',
            doc_count: 118,
          },
          {
            tag: 'combo',
            doc_count: 130,
          },
          {
            tag: 'running',
            doc_count: 64,
          },
          {
            tag: 'uppercut',
            doc_count: 84,
          },
          {
            tag: 'high',
            doc_count: 65,
          },
          {
            tag: 'cross',
            doc_count: 51,
          },
          {
            tag: 'double',
            doc_count: 43,
          },
          {
            tag: 'spin',
            doc_count: 35,
          },
          {
            tag: 'downward',
            doc_count: 28,
          },
          {
            tag: 'low',
            doc_count: 31,
          },
          {
            tag: 'backhand',
            doc_count: 15,
          },
          {
            tag: 'overhead',
            doc_count: 11,
          },
          {
            tag: 'super punch',
            doc_count: 11,
          },
          {
            tag: 'double-handed',
            doc_count: 10,
          },
          {
            tag: 'weak',
            doc_count: 12,
          },
          {
            tag: 'ground pound',
            doc_count: 5,
          },
          {
            tag: 'haymaker',
            doc_count: 8,
          },
          {
            tag: 'triple',
            doc_count: 6,
          },
          {
            tag: 'elbow',
            doc_count: 2,
          },
          {
            tag: 'slap',
            doc_count: 2,
          },
          {
            tag: 'windmill',
            doc_count: 1,
          },
          {
            tag: 'fake punch',
            doc_count: 3,
          },
          {
            tag: 'counter',
            doc_count: 3,
          },
        ],
      },
      {
        subcategory: 'recovery',
        doc_count: 328,
        tags: [
          {
            tag: 'regain balance',
            doc_count: 180,
          },
          {
            tag: 'stabilize',
            doc_count: 70,
          },
          {
            tag: 'get up',
            doc_count: 79,
          },
          {
            tag: 'stagger',
            doc_count: 39,
          },
          {
            tag: 'shake it off',
            doc_count: 32,
          },
          {
            tag: 'reset',
            doc_count: 13,
          },
          {
            tag: 'ready up',
            doc_count: 7,
          },
          {
            tag: 'stumble',
            doc_count: 5,
          },
          {
            tag: 'clutch wound',
            doc_count: 4,
          },
          {
            tag: 'wipe face',
            doc_count: 1,
          },
          {
            tag: 'catch breath',
            doc_count: 3,
          },
        ],
      },
      {
        subcategory: 'tactical movement',
        doc_count: 582,
        tags: [
          {
            tag: 'advance',
            doc_count: 163,
          },
          {
            tag: 'sidestep',
            doc_count: 106,
          },
          {
            tag: 'spin',
            doc_count: 51,
          },
          {
            tag: 'right',
            doc_count: 43,
          },
          {
            tag: 'forward',
            doc_count: 35,
          },
          {
            tag: 'backstep',
            doc_count: 45,
          },
          {
            tag: 'left',
            doc_count: 31,
          },
          {
            tag: 'wide stance',
            doc_count: 38,
          },
          {
            tag: 'crouch',
            doc_count: 24,
          },
          {
            tag: 'retreat',
            doc_count: 37,
          },
          {
            tag: 'side',
            doc_count: 15,
          },
          {
            tag: 'defense',
            doc_count: 11,
          },
          {
            tag: 'backward',
            doc_count: 8,
          },
          {
            tag: 'weapon carry',
            doc_count: 7,
          },
          {
            tag: 'draw weapon',
            doc_count: 3,
          },
          {
            tag: 'aim',
            doc_count: 5,
          },
          {
            tag: 'take cover',
            doc_count: 6,
          },
          {
            tag: 'strafe',
            doc_count: 3,
          },
          {
            tag: 'holster',
            doc_count: 3,
          },
          {
            tag: 'check surroundings',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'unarmed attack',
        doc_count: 1508,
        tags: [
          {
            tag: 'punch',
            doc_count: 753,
          },
          {
            tag: 'powerful',
            doc_count: 471,
          },
          {
            tag: 'kick',
            doc_count: 360,
          },
          {
            tag: 'high attack',
            doc_count: 211,
          },
          {
            tag: 'spin',
            doc_count: 140,
          },
          {
            tag: 'rapid strike',
            doc_count: 168,
          },
          {
            tag: 'charge',
            doc_count: 82,
          },
          {
            tag: 'jump',
            doc_count: 52,
          },
          {
            tag: 'karate',
            doc_count: 47,
          },
          {
            tag: 'leg attack',
            doc_count: 66,
          },
          {
            tag: 'slap',
            doc_count: 33,
          },
          {
            tag: 'low blow',
            doc_count: 22,
          },
          {
            tag: 'arm attack',
            doc_count: 13,
          },
          {
            tag: 'body slam',
            doc_count: 11,
          },
          {
            tag: 'headbutt',
            doc_count: 15,
          },
          {
            tag: 'elbow',
            doc_count: 8,
          },
          {
            tag: 'aerial',
            doc_count: 9,
          },
          {
            tag: 'fake',
            doc_count: 7,
          },
          {
            tag: 'martial arts',
            doc_count: 11,
          },
          {
            tag: 'counter attack',
            doc_count: 4,
          },
          {
            tag: 'head attack',
            doc_count: 8,
          },
          {
            tag: 'chest attack',
            doc_count: 6,
          },
          {
            tag: 'stomach attack',
            doc_count: 5,
          },
          {
            tag: 'grapple',
            doc_count: 2,
          },
          {
            tag: 'ambush',
            doc_count: 2,
          },
          {
            tag: 'throat grab',
            doc_count: 2,
          },
          {
            tag: 'duck',
            doc_count: 3,
          },
          {
            tag: 'choke hold',
            doc_count: 1,
          },
          {
            tag: 'headlock',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'unarmed defend',
        doc_count: 236,
        tags: [
          {
            tag: 'block',
            doc_count: 126,
          },
          {
            tag: 'defensive stance',
            doc_count: 84,
          },
          {
            tag: 'face block',
            doc_count: 48,
          },
          {
            tag: 'sidestep',
            doc_count: 42,
          },
          {
            tag: 'backstep',
            doc_count: 28,
          },
          {
            tag: 'high block',
            doc_count: 25,
          },
          {
            tag: 'dodge',
            doc_count: 27,
          },
          {
            tag: 'left',
            doc_count: 16,
          },
          {
            tag: 'right',
            doc_count: 20,
          },
          {
            tag: 'arm block',
            doc_count: 12,
          },
          {
            tag: 'spin',
            doc_count: 8,
          },
          {
            tag: 'low block',
            doc_count: 8,
          },
          {
            tag: 'bob and weave',
            doc_count: 5,
          },
          {
            tag: 'disarm',
            doc_count: 3,
          },
          {
            tag: 'evade',
            doc_count: 1,
          },
          {
            tag: 'groin protect',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'weapon attack',
        doc_count: 360,
        tags: [
          {
            tag: 'swing',
            doc_count: 177,
          },
          {
            tag: 'sword',
            doc_count: 125,
          },
          {
            tag: 'overhead',
            doc_count: 88,
          },
          {
            tag: '2 hand weapon',
            doc_count: 62,
          },
          {
            tag: '1 hand weapon',
            doc_count: 76,
          },
          {
            tag: 'heavy',
            doc_count: 47,
          },
          {
            tag: 'stab',
            doc_count: 52,
          },
          {
            tag: 'slice',
            doc_count: 28,
          },
          {
            tag: 'forwards',
            doc_count: 35,
          },
          {
            tag: 'slam',
            doc_count: 29,
          },
          {
            tag: 'melee',
            doc_count: 25,
          },
          {
            tag: 'spin',
            doc_count: 8,
          },
          {
            tag: 'hammer',
            doc_count: 17,
          },
          {
            tag: 'dual wield',
            doc_count: 9,
          },
          {
            tag: 'shoot',
            doc_count: 26,
          },
          {
            tag: 'axe',
            doc_count: 16,
          },
          {
            tag: 'spear',
            doc_count: 13,
          },
          {
            tag: 'backhand',
            doc_count: 7,
          },
          {
            tag: 'ranged',
            doc_count: 19,
          },
          {
            tag: 'knife',
            doc_count: 13,
          },
          {
            tag: 'recoil',
            doc_count: 16,
          },
          {
            tag: 'aim',
            doc_count: 11,
          },
          {
            tag: 'backwards',
            doc_count: 3,
          },
          {
            tag: 'charge',
            doc_count: 3,
          },
          {
            tag: 'bow and arrow',
            doc_count: 10,
          },
          {
            tag: 'aerial',
            doc_count: 1,
          },
          {
            tag: 'energy blast',
            doc_count: 6,
          },
          {
            tag: 'holster',
            doc_count: 4,
          },
          {
            tag: 'shield',
            doc_count: 1,
          },
          {
            tag: 'load weapon',
            doc_count: 3,
          },
          {
            tag: 'bazooka',
            doc_count: 2,
          },
          {
            tag: 'battering ram',
            doc_count: 2,
          },
          {
            tag: 'counter attack',
            doc_count: 1,
          },
          {
            tag: 'bowstaff',
            doc_count: 1,
          },
          {
            tag: 'bat',
            doc_count: 1,
          },
          {
            tag: 'hadouken',
            doc_count: 1,
          },
          {
            tag: 'stick',
            doc_count: 1,
          },
          {
            tag: 'blunt weapon',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'weapon defend',
        doc_count: 39,
        tags: [
          {
            tag: 'parry',
            doc_count: 9,
          },
          {
            tag: 'shield',
            doc_count: 17,
          },
          {
            tag: 'block',
            doc_count: 9,
          },
          {
            tag: 'sword',
            doc_count: 5,
          },
          {
            tag: 'holster',
            doc_count: 2,
          },
          {
            tag: 'counter',
            doc_count: 1,
          },
          {
            tag: 'deflect',
            doc_count: 2,
          },
          {
            tag: 'disarm',
            doc_count: 1,
          },
        ],
      },
    ],
  },
  {
    category: 'cycles',
    doc_count: 800,
    subcategories: [
      {
        subcategory: 'featured',
        doc_count: 17,
        tags: [],
      },
      {
        subcategory: 'jumping',
        doc_count: 12,
        tags: [],
      },
      {
        subcategory: 'pushing/pulling',
        doc_count: 6,
        tags: [],
      },
      {
        subcategory: 'running',
        doc_count: 3,
        tags: [],
      },
      {
        subcategory: 'sliding',
        doc_count: 1,
        tags: [],
      },
      {
        subcategory: 'sneaking',
        doc_count: 30,
        tags: [],
      },
      {
        subcategory: 'walking',
        doc_count: 800,
        tags: [],
      },
      {
        subcategory: 'unsteady',
        doc_count: 263,
        tags: [],
      },
    ],
  },
  {
    category: 'dance',
    doc_count: 1266,
    subcategories: [
      {
        subcategory: 'featured',
        doc_count: 44,
        tags: [],
      },
      {
        subcategory: 'breakdancing',
        doc_count: 29,
        tags: [
          {
            tag: 'spin',
            doc_count: 23,
          },
          {
            tag: 'powermove',
            doc_count: 11,
          },
          {
            tag: '360',
            doc_count: 6,
          },
          {
            tag: 'kick',
            doc_count: 6,
          },
          {
            tag: 'footwork',
            doc_count: 6,
          },
          {
            tag: 'jump',
            doc_count: 4,
          },
          {
            tag: 'handstand',
            doc_count: 5,
          },
          {
            tag: 'wave',
            doc_count: 1,
          },
          {
            tag: 'headspin',
            doc_count: 3,
          },
          {
            tag: 'leg spin',
            doc_count: 1,
          },
          {
            tag: 'backspin',
            doc_count: 2,
          },
          {
            tag: 'floorwork',
            doc_count: 3,
          },
          {
            tag: 'backflip',
            doc_count: 2,
          },
          {
            tag: '720',
            doc_count: 2,
          },
          {
            tag: 'reverse',
            doc_count: 1,
          },
          {
            tag: 'freeze',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'easy moves',
        doc_count: 223,
        tags: [
          {
            tag: 'sway',
            doc_count: 89,
          },
          {
            tag: 'sidestep',
            doc_count: 56,
          },
          {
            tag: 'arm raise',
            doc_count: 38,
          },
          {
            tag: 'bounce',
            doc_count: 37,
          },
          {
            tag: 'wave',
            doc_count: 21,
          },
          {
            tag: 'wiggle',
            doc_count: 36,
          },
          {
            tag: 'hop',
            doc_count: 26,
          },
          {
            tag: 'hip shake',
            doc_count: 27,
          },
          {
            tag: 'shimmy',
            doc_count: 11,
          },
          {
            tag: 'jump',
            doc_count: 12,
          },
          {
            tag: 'simple swinging',
            doc_count: 4,
          },
          {
            tag: 'clap',
            doc_count: 5,
          },
          {
            tag: 'squat',
            doc_count: 4,
          },
          {
            tag: 'grapevine',
            doc_count: 2,
          },
          {
            tag: 'head nod',
            doc_count: 3,
          },
          {
            tag: 'tiptoe',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'emotes',
        doc_count: 83,
        tags: [
          {
            tag: 'dab',
            doc_count: 9,
          },
          {
            tag: 'floss',
            doc_count: 7,
          },
          {
            tag: 'tiktok dance',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'freeform',
        doc_count: 356,
        tags: [
          {
            tag: 'spin',
            doc_count: 92,
          },
          {
            tag: 'arm movements',
            doc_count: 102,
          },
          {
            tag: '180',
            doc_count: 32,
          },
          {
            tag: 'sidestep',
            doc_count: 48,
          },
          {
            tag: 'rhythmic',
            doc_count: 42,
          },
          {
            tag: 'stretch',
            doc_count: 28,
          },
          {
            tag: 'twirl',
            doc_count: 20,
          },
          {
            tag: 'hip shake',
            doc_count: 37,
          },
          {
            tag: 'groove',
            doc_count: 25,
          },
          {
            tag: 'bounce',
            doc_count: 27,
          },
          {
            tag: 'windmill',
            doc_count: 5,
          },
          {
            tag: 'pose',
            doc_count: 15,
          },
          {
            tag: 'body roll',
            doc_count: 10,
          },
          {
            tag: 'improv',
            doc_count: 19,
          },
          {
            tag: 'freestyle',
            doc_count: 14,
          },
          {
            tag: 'forwards',
            doc_count: 11,
          },
          {
            tag: 'backwards',
            doc_count: 11,
          },
          {
            tag: 'wobble',
            doc_count: 10,
          },
          {
            tag: 'slow',
            doc_count: 11,
          },
          {
            tag: 'practice',
            doc_count: 7,
          },
          {
            tag: 'graceful',
            doc_count: 5,
          },
          {
            tag: 'interpretive',
            doc_count: 4,
          },
          {
            tag: 'crouched dance',
            doc_count: 1,
          },
          {
            tag: 'aerobic',
            doc_count: 5,
          },
          {
            tag: 'pirouette',
            doc_count: 2,
          },
          {
            tag: 'yoga',
            doc_count: 1,
          },
          {
            tag: 'clap',
            doc_count: 1,
          },
          {
            tag: 'partner dance',
            doc_count: 2,
          },
          {
            tag: 'figure eight',
            doc_count: 2,
          },
          {
            tag: 'hula hoop',
            doc_count: 2,
          },
          {
            tag: 'belly dance',
            doc_count: 1,
          },
          {
            tag: 'zumba',
            doc_count: 1,
          },
          {
            tag: 'jazzercise',
            doc_count: 1,
          },
          {
            tag: 'jam session',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'hiphop',
        doc_count: 102,
        tags: [
          {
            tag: 'hip shake',
            doc_count: 28,
          },
          {
            tag: 'arm pump',
            doc_count: 21,
          },
          {
            tag: 'kick',
            doc_count: 22,
          },
          {
            tag: 'shuffle',
            doc_count: 8,
          },
          {
            tag: 'high kick',
            doc_count: 11,
          },
          {
            tag: 'circle walk',
            doc_count: 4,
          },
          {
            tag: 'pump',
            doc_count: 7,
          },
          {
            tag: 'head bob',
            doc_count: 6,
          },
          {
            tag: 'shimmy',
            doc_count: 7,
          },
          {
            tag: 'crossover',
            doc_count: 4,
          },
          {
            tag: 'pop',
            doc_count: 2,
          },
          {
            tag: 'energetic kicks',
            doc_count: 4,
          },
          {
            tag: 'backward',
            doc_count: 3,
          },
          {
            tag: 'chassé',
            doc_count: 1,
          },
          {
            tag: 'forward',
            doc_count: 2,
          },
          {
            tag: 'stanky leg',
            doc_count: 2,
          },
          {
            tag: 'line kick',
            doc_count: 2,
          },
          {
            tag: 'kneel',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'iconic song dances',
        doc_count: 24,
        tags: [
          {
            tag: 'moonwalk',
            doc_count: 10,
          },
          {
            tag: 'macarena',
            doc_count: 7,
          },
          {
            tag: 'chicken dance',
            doc_count: 1,
          },
          {
            tag: 'gangnam style',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'party dances',
        doc_count: 230,
        tags: [
          {
            tag: 'stanky leg',
            doc_count: 4,
          },
          {
            tag: 'teapot',
            doc_count: 2,
          },
          {
            tag: 'sprinkler',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'traditional dances',
        doc_count: 175,
        tags: [
          {
            tag: 'ballet',
            doc_count: 15,
          },
          {
            tag: 'waltz',
            doc_count: 9,
          },
          {
            tag: 'salsa',
            doc_count: 10,
          },
          {
            tag: 'ballroom',
            doc_count: 2,
          },
          {
            tag: 'partner dance',
            doc_count: 1,
          },
          {
            tag: 'square dance',
            doc_count: 3,
          },
          {
            tag: 'east coast swing',
            doc_count: 2,
          },
          {
            tag: 'folk',
            doc_count: 2,
          },
          {
            tag: 'texas two step',
            doc_count: 1,
          },
          {
            tag: 'slow dance',
            doc_count: 1,
          },
          {
            tag: 'tap dance',
            doc_count: 1,
          },
          {
            tag: 'egyptian',
            doc_count: 1,
          },
        ],
      },
    ],
  },
  {
    category: 'environment interaction',
    doc_count: 1887,
    subcategories: [
      {
        subcategory: 'featured',
        doc_count: 44,
        tags: [],
      },
      {
        subcategory: 'cliffs and drops',
        doc_count: 12,
        tags: [
          {
            tag: 'ledge',
            doc_count: 3,
          },
          {
            tag: 'cliff',
            doc_count: 6,
          },
        ],
      },
      {
        subcategory: 'doors',
        doc_count: 94,
        tags: [
          {
            tag: 'sliding door',
            doc_count: 10,
          },
          {
            tag: 'double door',
            doc_count: 11,
          },
          {
            tag: 'doorbell',
            doc_count: 11,
          },
          {
            tag: 'keypad',
            doc_count: 2,
          },
          {
            tag: 'garage door',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'extreme conditions',
        doc_count: 5,
        tags: [
          {
            tag: 'wind',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'household & furnishings',
        doc_count: 81,
        tags: [
          {
            tag: 'sink',
            doc_count: 13,
          },
          {
            tag: 'shelf',
            doc_count: 9,
          },
          {
            tag: 'carpet',
            doc_count: 6,
          },
          {
            tag: 'chair',
            doc_count: 3,
          },
          {
            tag: 'refrigerator',
            doc_count: 2,
          },
          {
            tag: 'table',
            doc_count: 1,
          },
          {
            tag: 'wardrobe',
            doc_count: 2,
          },
          {
            tag: 'plant',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'inclines',
        doc_count: 80,
        tags: [
          {
            tag: 'ramp',
            doc_count: 41,
          },
          {
            tag: 'hill',
            doc_count: 32,
          },
        ],
      },
      {
        subcategory: 'outdoors',
        doc_count: 70,
        tags: [
          {
            tag: 'water',
            doc_count: 24,
          },
          {
            tag: 'tree',
            doc_count: 9,
          },
          {
            tag: 'rock',
            doc_count: 9,
          },
          {
            tag: 'grass',
            doc_count: 3,
          },
        ],
      },
      {
        subcategory: 'platforms',
        doc_count: 443,
        tags: [
          {
            tag: 'ledge',
            doc_count: 124,
          },
          {
            tag: 'box',
            doc_count: 94,
          },
          {
            tag: 'curb',
            doc_count: 21,
          },
          {
            tag: 'roof',
            doc_count: 3,
          },
        ],
      },
      {
        subcategory: 'stairs',
        doc_count: 397,
        tags: [
          {
            tag: 'small steps',
            doc_count: 234,
          },
          {
            tag: 'handrail',
            doc_count: 92,
          },
          {
            tag: 'big steps',
            doc_count: 72,
          },
        ],
      },
      {
        subcategory: 'tables',
        doc_count: 252,
        tags: [
          {
            tag: 'table',
            doc_count: 87,
          },
          {
            tag: 'counter',
            doc_count: 12,
          },
          {
            tag: 'desk',
            doc_count: 4,
          },
          {
            tag: 'bar',
            doc_count: 3,
          },
          {
            tag: 'drawer',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'uneven terrain',
        doc_count: 237,
        tags: [
          {
            tag: 'rocky',
            doc_count: 55,
          },
          {
            tag: 'bumpy',
            doc_count: 31,
          },
          {
            tag: 'balance beam',
            doc_count: 27,
          },
          {
            tag: 'dirt path',
            doc_count: 6,
          },
          {
            tag: 'icy',
            doc_count: 3,
          },
        ],
      },
      {
        subcategory: 'walls',
        doc_count: 172,
        tags: [
          {
            tag: 'wall',
            doc_count: 61,
          },
          {
            tag: 'fence',
            doc_count: 7,
          },
          {
            tag: 'corner',
            doc_count: 1,
          },
        ],
      },
    ],
  },
  {
    category: 'everyday',
    doc_count: 10605,
    subcategories: [
      {
        subcategory: 'featured',
        doc_count: 14,
        tags: [],
      },
      {
        subcategory: 'chores and tasks',
        doc_count: 1075,
        tags: [
          {
            tag: 'move item',
            doc_count: 290,
          },
          {
            tag: 'pick up',
            doc_count: 232,
          },
          {
            tag: 'carry',
            doc_count: 168,
          },
          {
            tag: 'clean',
            doc_count: 126,
          },
          {
            tag: 'wash',
            doc_count: 82,
          },
          {
            tag: 'remove item',
            doc_count: 57,
          },
          {
            tag: 'cook',
            doc_count: 54,
          },
          {
            tag: 'open container',
            doc_count: 48,
          },
          {
            tag: 'fill container',
            doc_count: 48,
          },
          {
            tag: 'adjust clothing',
            doc_count: 27,
          },
          {
            tag: 'look around',
            doc_count: 20,
          },
          {
            tag: 'dishes',
            doc_count: 28,
          },
          {
            tag: 'build',
            doc_count: 15,
          },
          {
            tag: 'pull object',
            doc_count: 16,
          },
          {
            tag: 'repair',
            doc_count: 15,
          },
          {
            tag: 'trash',
            doc_count: 11,
          },
          {
            tag: 'push object',
            doc_count: 11,
          },
          {
            tag: 'garden',
            doc_count: 14,
          },
          {
            tag: 'close',
            doc_count: 13,
          },
          {
            tag: 'dig',
            doc_count: 18,
          },
          {
            tag: 'write',
            doc_count: 13,
          },
          {
            tag: 'break',
            doc_count: 7,
          },
          {
            tag: 'hang on wall',
            doc_count: 11,
          },
          {
            tag: 'draw',
            doc_count: 5,
          },
          {
            tag: 'animal care',
            doc_count: 6,
          },
          {
            tag: 'shopping',
            doc_count: 1,
          },
          {
            tag: 'laundry',
            doc_count: 1,
          },
          {
            tag: 'check mail',
            doc_count: 1,
          },
          {
            tag: 'make bed',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'eating and drinking',
        doc_count: 109,
        tags: [
          {
            tag: 'drink',
            doc_count: 61,
          },
          {
            tag: 'sip',
            doc_count: 23,
          },
          {
            tag: 'eat',
            doc_count: 20,
          },
          {
            tag: 'chew',
            doc_count: 7,
          },
          {
            tag: 'bite',
            doc_count: 5,
          },
          {
            tag: 'swallow',
            doc_count: 4,
          },
          {
            tag: 'taste',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'relaxation',
        doc_count: 714,
        tags: [
          {
            tag: 'stretch',
            doc_count: 221,
          },
          {
            tag: 'lean',
            doc_count: 34,
          },
          {
            tag: 'ponder',
            doc_count: 30,
          },
          {
            tag: 'meditate',
            doc_count: 34,
          },
          {
            tag: 'doze',
            doc_count: 20,
          },
          {
            tag: 'bend',
            doc_count: 15,
          },
          {
            tag: 'scratch',
            doc_count: 17,
          },
          {
            tag: 'pray',
            doc_count: 12,
          },
          {
            tag: 'yoga',
            doc_count: 10,
          },
          {
            tag: 'read',
            doc_count: 7,
          },
          {
            tag: 'fold arms',
            doc_count: 8,
          },
          {
            tag: 'bored',
            doc_count: 5,
          },
          {
            tag: 'watch tv',
            doc_count: 5,
          },
          {
            tag: 'look up',
            doc_count: 6,
          },
          {
            tag: 'neck crack',
            doc_count: 7,
          },
          {
            tag: 'pet animal',
            doc_count: 5,
          },
          {
            tag: 'breathing',
            doc_count: 5,
          },
          {
            tag: 'sunbathe',
            doc_count: 2,
          },
          {
            tag: 'exhale',
            doc_count: 4,
          },
          {
            tag: 'check phone',
            doc_count: 4,
          },
          {
            tag: 'check watch',
            doc_count: 1,
          },
          {
            tag: 'belly pat',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'self care',
        doc_count: 1654,
        tags: [
          {
            tag: 'stretch',
            doc_count: 713,
          },
          {
            tag: 'adjust clothing',
            doc_count: 80,
          },
          {
            tag: 'fix hair',
            doc_count: 69,
          },
          {
            tag: 'clean face',
            doc_count: 69,
          },
          {
            tag: 'bandage',
            doc_count: 20,
          },
          {
            tag: 'pick nose',
            doc_count: 17,
          },
          {
            tag: 'brush teeth',
            doc_count: 8,
          },
          {
            tag: 'bathe',
            doc_count: 6,
          },
          {
            tag: 'get dressed',
            doc_count: 5,
          },
          {
            tag: 'take medicine',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'sleeping',
        doc_count: 148,
        tags: [
          {
            tag: 'wake up',
            doc_count: 18,
          },
          {
            tag: 'go to bed',
            doc_count: 14,
          },
          {
            tag: 'fetal position',
            doc_count: 5,
          },
          {
            tag: 'toss and turn',
            doc_count: 5,
          },
          {
            tag: 'roll over',
            doc_count: 6,
          },
          {
            tag: 'morning stretch',
            doc_count: 3,
          },
        ],
      },
      {
        subcategory: 'work',
        doc_count: 27,
        tags: [
          {
            tag: 'whiteboard',
            doc_count: 2,
          },
          {
            tag: 'operate machine',
            doc_count: 3,
          },
          {
            tag: 'type',
            doc_count: 2,
          },
          {
            tag: 'assembly line',
            doc_count: 2,
          },
          {
            tag: 'office chair',
            doc_count: 1,
          },
          {
            tag: 'slouch',
            doc_count: 1,
          },
        ],
      },
    ],
  },
  {
    category: 'idle',
    doc_count: 2996,
    subcategories: [
      {
        subcategory: 'crouch',
        doc_count: 189,
        tags: [
          {
            tag: 'squat',
            doc_count: 72,
          },
          {
            tag: 'low stance',
            doc_count: 81,
          },
          {
            tag: 'wide legs',
            doc_count: 20,
          },
          {
            tag: 'sit on heels',
            doc_count: 7,
          },
        ],
      },
      {
        subcategory: 'dangling',
        doc_count: 20,
        tags: [
          {
            tag: '2 hand',
            doc_count: 8,
          },
          {
            tag: 'legs',
            doc_count: 9,
          },
          {
            tag: 'ledge',
            doc_count: 2,
          },
          {
            tag: '1 hand',
            doc_count: 2,
          },
          {
            tag: 'rope',
            doc_count: 2,
          },
          {
            tag: 'bar',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'hiding',
        doc_count: 17,
        tags: [
          {
            tag: 'hide face',
            doc_count: 11,
          },
          {
            tag: 'cower',
            doc_count: 7,
          },
          {
            tag: 'low cover',
            doc_count: 6,
          },
          {
            tag: 'huddled away',
            doc_count: 4,
          },
        ],
      },
      {
        subcategory: 'kneeling',
        doc_count: 310,
        tags: [
          {
            tag: 'bow',
            doc_count: 99,
          },
          {
            tag: '1 knee',
            doc_count: 74,
          },
          {
            tag: '2 knees',
            doc_count: 66,
          },
          {
            tag: 'prayer',
            doc_count: 56,
          },
          {
            tag: 'surrender',
            doc_count: 50,
          },
          {
            tag: 'hands on knees',
            doc_count: 35,
          },
          {
            tag: 'worship',
            doc_count: 30,
          },
          {
            tag: 'rest',
            doc_count: 22,
          },
          {
            tag: 'arms raised',
            doc_count: 20,
          },
          {
            tag: 'folded arms',
            doc_count: 8,
          },
          {
            tag: 'slouch',
            doc_count: 6,
          },
        ],
      },
      {
        subcategory: 'leaning',
        doc_count: 205,
        tags: [
          {
            tag: 'side',
            doc_count: 65,
          },
          {
            tag: 'forward',
            doc_count: 52,
          },
          {
            tag: 'backward',
            doc_count: 25,
          },
          {
            tag: 'arm against surface',
            doc_count: 18,
          },
          {
            tag: 'against wall',
            doc_count: 19,
          },
          {
            tag: 'bent over',
            doc_count: 13,
          },
          {
            tag: 'on thighs',
            doc_count: 9,
          },
          {
            tag: 'folded arms',
            doc_count: 5,
          },
        ],
      },
      {
        subcategory: 'lying down',
        doc_count: 225,
        tags: [
          {
            tag: 'arms at side',
            doc_count: 74,
          },
          {
            tag: 'legs bent',
            doc_count: 75,
          },
          {
            tag: 'face down',
            doc_count: 70,
          },
          {
            tag: 'face up',
            doc_count: 66,
          },
          {
            tag: 'arms spread out',
            doc_count: 64,
          },
          {
            tag: 'legs straight',
            doc_count: 61,
          },
          {
            tag: 'sprawled',
            doc_count: 44,
          },
          {
            tag: 'fetal position',
            doc_count: 8,
          },
          {
            tag: 'hands behind head',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'sitting',
        doc_count: 755,
        tags: [
          {
            tag: 'legs crossed',
            doc_count: 374,
          },
          {
            tag: 'arms folded',
            doc_count: 313,
          },
          {
            tag: 'chair',
            doc_count: 168,
          },
          {
            tag: 'criss cross',
            doc_count: 37,
          },
          {
            tag: 'ground',
            doc_count: 51,
          },
          {
            tag: 'slouch',
            doc_count: 66,
          },
          {
            tag: 'bench',
            doc_count: 38,
          },
          {
            tag: 'meditate',
            doc_count: 28,
          },
          {
            tag: 'couch',
            doc_count: 17,
          },
          {
            tag: 'bored',
            doc_count: 6,
          },
          {
            tag: 'wall sit',
            doc_count: 3,
          },
          {
            tag: 'work',
            doc_count: 3,
          },
          {
            tag: 'throne',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'standing',
        doc_count: 1269,
        tags: [
          {
            tag: 'relaxed',
            doc_count: 188,
          },
          {
            tag: 'shift weight',
            doc_count: 132,
          },
          {
            tag: 'contropposto',
            doc_count: 184,
          },
          {
            tag: 'arms crossed',
            doc_count: 190,
          },
          {
            tag: 'balance',
            doc_count: 64,
          },
          {
            tag: 'waiting',
            doc_count: 51,
          },
          {
            tag: 'look around',
            doc_count: 59,
          },
          {
            tag: '1 leg',
            doc_count: 34,
          },
          {
            tag: 'impatient',
            doc_count: 36,
          },
          {
            tag: 'hands on hips',
            doc_count: 30,
          },
          {
            tag: 'check watch',
            doc_count: 36,
          },
          {
            tag: 'shiver',
            doc_count: 10,
          },
          {
            tag: 'zone out',
            doc_count: 1,
          },
        ],
      },
    ],
  },
  {
    category: 'locomotion',
    doc_count: 11507,
    subcategories: [
      {
        subcategory: 'featured',
        doc_count: 48,
        tags: [],
      },
      {
        subcategory: 'climbing',
        doc_count: 158,
        tags: [
          {
            tag: 'stairs',
            doc_count: 105,
          },
          {
            tag: 'ladder',
            doc_count: 26,
          },
          {
            tag: 'rock climb',
            doc_count: 6,
          },
          {
            tag: 'rope climb',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'crawling',
        doc_count: 253,
        tags: [
          {
            tag: 'all fours',
            doc_count: 146,
          },
          {
            tag: 'backwards',
            doc_count: 29,
          },
          {
            tag: 'army crawl',
            doc_count: 22,
          },
          {
            tag: 'bear crawl',
            doc_count: 22,
          },
          {
            tag: 'crab walk',
            doc_count: 5,
          },
        ],
      },
      {
        subcategory: 'flying',
        doc_count: 62,
        tags: [
          {
            tag: 'glide',
            doc_count: 16,
          },
          {
            tag: 'vertical',
            doc_count: 8,
          },
          {
            tag: 'horizontal',
            doc_count: 11,
          },
          {
            tag: 'dive',
            doc_count: 4,
          },
        ],
      },
      {
        subcategory: 'jumping',
        doc_count: 1492,
        tags: [
          {
            tag: 'hop',
            doc_count: 438,
          },
          {
            tag: 'leap',
            doc_count: 195,
          },
          {
            tag: 'backward',
            doc_count: 146,
          },
          {
            tag: 'bound',
            doc_count: 27,
          },
          {
            tag: 'hopscotch',
            doc_count: 4,
          },
        ],
      },
      {
        subcategory: 'pushing/pulling',
        doc_count: 61,
        tags: [
          {
            tag: 'push object',
            doc_count: 35,
          },
          {
            tag: 'drag object',
            doc_count: 14,
          },
          {
            tag: 'carry',
            doc_count: 6,
          },
        ],
      },
      {
        subcategory: 'running',
        doc_count: 1220,
        tags: [
          {
            tag: 'sprint',
            doc_count: 576,
          },
          {
            tag: 'jog',
            doc_count: 655,
          },
          {
            tag: 'chase',
            doc_count: 8,
          },
        ],
      },
      {
        subcategory: 'skipping',
        doc_count: 59,
        tags: [
          {
            tag: 'backward',
            doc_count: 6,
          },
        ],
      },
      {
        subcategory: 'sliding',
        doc_count: 142,
        tags: [
          {
            tag: 'tactical slide',
            doc_count: 37,
          },
          {
            tag: 'backward',
            doc_count: 23,
          },
          {
            tag: 'icy',
            doc_count: 5,
          },
          {
            tag: 'knee slide',
            doc_count: 5,
          },
        ],
      },
      {
        subcategory: 'sneaking',
        doc_count: 168,
        tags: [
          {
            tag: 'crouch walk',
            doc_count: 100,
          },
          {
            tag: 'careful',
            doc_count: 56,
          },
          {
            tag: 'backward',
            doc_count: 36,
          },
          {
            tag: 'stealth walk',
            doc_count: 43,
          },
        ],
      },
      {
        subcategory: 'swimming',
        doc_count: 77,
        tags: [
          {
            tag: 'freestyle',
            doc_count: 43,
          },
          {
            tag: 'breaststroke',
            doc_count: 18,
          },
          {
            tag: 'underwater',
            doc_count: 14,
          },
          {
            tag: 'backstroke',
            doc_count: 4,
          },
          {
            tag: 'butterfly',
            doc_count: 3,
          },
          {
            tag: 'mermaid',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'unsteady',
        doc_count: 1197,
        tags: [
          {
            tag: 'stumble',
            doc_count: 672,
          },
          {
            tag: 'balance',
            doc_count: 246,
          },
          {
            tag: 'trip',
            doc_count: 221,
          },
          {
            tag: 'backward',
            doc_count: 173,
          },
          {
            tag: 'injured',
            doc_count: 115,
          },
          {
            tag: 'dizzy',
            doc_count: 116,
          },
          {
            tag: 'limp',
            doc_count: 84,
          },
          {
            tag: 'hobble',
            doc_count: 67,
          },
          {
            tag: 'drunken',
            doc_count: 72,
          },
          {
            tag: 'tired',
            doc_count: 19,
          },
          {
            tag: 'zombie',
            doc_count: 13,
          },
        ],
      },
      {
        subcategory: 'walking',
        doc_count: 6569,
        tags: [
          {
            tag: 'slow',
            doc_count: 1269,
          },
          {
            tag: 'backward',
            doc_count: 945,
          },
          {
            tag: 'quick',
            doc_count: 480,
          },
          {
            tag: 'confident',
            doc_count: 472,
          },
          {
            tag: 'nervous',
            doc_count: 210,
          },
          {
            tag: 'supported',
            doc_count: 183,
          },
          {
            tag: 'march',
            doc_count: 83,
          },
          {
            tag: 'fashion',
            doc_count: 56,
          },
        ],
      },
    ],
  },
  {
    category: 'music',
    doc_count: 150,
    subcategories: [
      {
        subcategory: 'brass',
        doc_count: 5,
        tags: [
          {
            tag: 'trumpet',
            doc_count: 5,
          },
        ],
      },
      {
        subcategory: 'conducting',
        doc_count: 20,
        tags: [
          {
            tag: '2 hand',
            doc_count: 15,
          },
          {
            tag: '1 hand',
            doc_count: 6,
          },
          {
            tag: 'baton',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'guitar',
        doc_count: 36,
        tags: [],
      },
      {
        subcategory: 'percussion',
        doc_count: 21,
        tags: [
          {
            tag: 'drums',
            doc_count: 14,
          },
          {
            tag: 'cymbal',
            doc_count: 3,
          },
          {
            tag: 'marimba',
            doc_count: 1,
          },
          {
            tag: 'gong',
            doc_count: 1,
          },
        ],
      },
      // {
      //   subcategory: 'piano',
      //   doc_count: 2,
      //   tags: [],
      // },
      {
        subcategory: 'singing',
        doc_count: 8,
        tags: [
          {
            tag: 'sing',
            doc_count: 7,
          },
          {
            tag: 'stage performance',
            doc_count: 6,
          },
          {
            tag: 'microphone',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'strings',
        doc_count: 52,
        tags: [
          {
            tag: 'violin',
            doc_count: 19,
          },
          {
            tag: 'viola',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'woodwind',
        doc_count: 5,
        tags: [
          {
            tag: 'flute',
            doc_count: 5,
          },
        ],
      },
    ],
  },
  {
    category: 'reactions and outbursts',
    doc_count: 1257,
    subcategories: [
      {
        subcategory: 'emotional outbursts',
        doc_count: 385,
        tags: [
          {
            tag: 'angry',
            doc_count: 56,
          },
          {
            tag: 'annoyed',
            doc_count: 45,
          },
          {
            tag: 'celebrate',
            doc_count: 45,
          },
          {
            tag: 'disappointed',
            doc_count: 47,
          },
          {
            tag: 'cry',
            doc_count: 37,
          },
          {
            tag: 'cheer',
            doc_count: 27,
          },
          {
            tag: 'applaud',
            doc_count: 29,
          },
          {
            tag: 'clap',
            doc_count: 26,
          },
          {
            tag: 'yell',
            doc_count: 23,
          },
          {
            tag: 'anxiety',
            doc_count: 16,
          },
          {
            tag: 'jump for joy',
            doc_count: 12,
          },
          {
            tag: 'sick',
            doc_count: 7,
          },
          {
            tag: 'surprised',
            doc_count: 7,
          },
          {
            tag: 'tantrum',
            doc_count: 5,
          },
          {
            tag: 'faint',
            doc_count: 7,
          },
          {
            tag: 'shocked',
            doc_count: 5,
          },
          {
            tag: 'disgusted',
            doc_count: 2,
          },
          {
            tag: 'scared',
            doc_count: 5,
          },
          {
            tag: 'laugh',
            doc_count: 4,
          },
          {
            tag: 'in love',
            doc_count: 3,
          },
          {
            tag: 'afraid',
            doc_count: 4,
          },
          {
            tag: 'shock',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'interaction reactions',
        doc_count: 122,
        tags: [
          {
            tag: 'greet',
            doc_count: 25,
          },
          {
            tag: 'intimidate',
            doc_count: 8,
          },
          {
            tag: 'encourage',
            doc_count: 4,
          },
          {
            tag: 'shush',
            doc_count: 1,
          },
          {
            tag: 'mock',
            doc_count: 1,
          },
          {
            tag: 'beg',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'reflex reactions',
        doc_count: 747,
        tags: [
          {
            tag: 'recoil',
            doc_count: 222,
          },
          {
            tag: 'startle',
            doc_count: 76,
          },
          {
            tag: 'flinch',
            doc_count: 64,
          },
          {
            tag: 'cover face',
            doc_count: 77,
          },
          {
            tag: 'hands up',
            doc_count: 31,
          },
          {
            tag: 'sneeze',
            doc_count: 23,
          },
          {
            tag: 'swat away',
            doc_count: 18,
          },
          {
            tag: 'double take',
            doc_count: 6,
          },
        ],
      },
    ],
  },
  {
    category: 'sports',
    doc_count: 1042,
    subcategories: [
      {
        subcategory: 'featured',
        doc_count: 61,
        tags: [],
      },
      {
        subcategory: 'baseball/softball',
        doc_count: 123,
        tags: [
          {
            tag: 'throw ball',
            doc_count: 76,
          },
          {
            tag: 'pitch',
            doc_count: 64,
          },
          {
            tag: 'overhand',
            doc_count: 60,
          },
          {
            tag: 'swing bat',
            doc_count: 15,
          },
          {
            tag: 'batting stance',
            doc_count: 3,
          },
          {
            tag: 'warm up',
            doc_count: 6,
          },
          {
            tag: 'catch',
            doc_count: 3,
          },
          {
            tag: 'slide',
            doc_count: 5,
          },
          {
            tag: 'underhand',
            doc_count: 3,
          },
          {
            tag: 'call safe',
            doc_count: 3,
          },
        ],
      },
      {
        subcategory: 'basketball',
        doc_count: 65,
        tags: [
          {
            tag: 'dribble',
            doc_count: 41,
          },
          {
            tag: 'shoot',
            doc_count: 19,
          },
          {
            tag: 'jump',
            doc_count: 13,
          },
          {
            tag: 'behind the back',
            doc_count: 6,
          },
          {
            tag: 'bounce',
            doc_count: 6,
          },
          {
            tag: 'fake out',
            doc_count: 6,
          },
          {
            tag: 'dunk',
            doc_count: 1,
          },
          {
            tag: 'between legs',
            doc_count: 2,
          },
          {
            tag: 'call foul',
            doc_count: 3,
          },
          {
            tag: 'call travel',
            doc_count: 2,
          },
          {
            tag: 'pass',
            doc_count: 2,
          },
          {
            tag: 'ready stance',
            doc_count: 1,
          },
          {
            tag: 'rebound',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'boxing',
        doc_count: 77,
        tags: [
          {
            tag: 'jab',
            doc_count: 45,
          },
          {
            tag: 'combo',
            doc_count: 29,
          },
          {
            tag: 'footwork',
            doc_count: 25,
          },
          {
            tag: 'bob',
            doc_count: 14,
          },
          {
            tag: 'uppercut',
            doc_count: 17,
          },
          {
            tag: 'cross',
            doc_count: 14,
          },
          {
            tag: 'hook',
            doc_count: 12,
          },
          {
            tag: 'guard',
            doc_count: 6,
          },
          {
            tag: 'bounce',
            doc_count: 7,
          },
          {
            tag: 'sidestep',
            doc_count: 6,
          },
          {
            tag: 'block',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'football',
        doc_count: 70,
        tags: [
          {
            tag: 'catch',
            doc_count: 21,
          },
          {
            tag: 'sprint',
            doc_count: 4,
          },
          {
            tag: 'juke',
            doc_count: 8,
          },
          {
            tag: 'touchdown celebration',
            doc_count: 3,
          },
          {
            tag: 'punt',
            doc_count: 4,
          },
          {
            tag: 'tackle',
            doc_count: 1,
          },
          {
            tag: 'backpedal',
            doc_count: 1,
          },
          {
            tag: 'field goal',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'golf',
        doc_count: 86,
        tags: [
          {
            tag: 'swing',
            doc_count: 65,
          },
          {
            tag: 'backswing',
            doc_count: 40,
          },
          {
            tag: 'follow through',
            doc_count: 36,
          },
          {
            tag: 'putt',
            doc_count: 25,
          },
          {
            tag: 'drive',
            doc_count: 11,
          },
        ],
      },
      {
        subcategory: 'gym motions and exercise',
        doc_count: 324,
        tags: [
          {
            tag: 'cardio',
            doc_count: 144,
          },
          {
            tag: 'squat',
            doc_count: 30,
          },
          {
            tag: 'upper legs',
            doc_count: 29,
          },
          {
            tag: 'lower legs',
            doc_count: 26,
          },
          {
            tag: 'shoulders',
            doc_count: 24,
          },
          {
            tag: 'weightlift',
            doc_count: 21,
          },
          {
            tag: 'triceps',
            doc_count: 12,
          },
          {
            tag: 'biceps',
            doc_count: 11,
          },
          {
            tag: 'curl',
            doc_count: 7,
          },
          {
            tag: 'upper back',
            doc_count: 7,
          },
          {
            tag: 'pullups',
            doc_count: 5,
          },
          {
            tag: 'abs',
            doc_count: 5,
          },
          {
            tag: 'lower back',
            doc_count: 3,
          },
        ],
      },
      {
        subcategory: 'ice skating/hockey',
        doc_count: 11,
        tags: [
          {
            tag: 'skate',
            doc_count: 7,
          },
          {
            tag: 'spin',
            doc_count: 3,
          },
          {
            tag: 'figure skate',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'soccer',
        doc_count: 117,
        tags: [
          {
            tag: 'kick',
            doc_count: 90,
          },
          {
            tag: 'dribble',
            doc_count: 6,
          },
          {
            tag: 'bicycle kick',
            doc_count: 4,
          },
          {
            tag: 'fake out',
            doc_count: 3,
          },
          {
            tag: 'header',
            doc_count: 2,
          },
          {
            tag: 'goalie dive',
            doc_count: 2,
          },
          {
            tag: 'goal celebration',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'swimming',
        doc_count: 57,
        tags: [
          {
            tag: 'freestyle',
            doc_count: 27,
          },
          {
            tag: 'breaststroke',
            doc_count: 19,
          },
          {
            tag: 'backstroke',
            doc_count: 4,
          },
          {
            tag: 'butterfly',
            doc_count: 5,
          },
          {
            tag: 'stretch',
            doc_count: 3,
          },
          {
            tag: 'float',
            doc_count: 2,
          },
          {
            tag: 'underwater',
            doc_count: 1,
          },
          {
            tag: 'doggy paddle',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'tennis',
        doc_count: 29,
        tags: [
          {
            tag: 'serve',
            doc_count: 16,
          },
          {
            tag: 'backhand',
            doc_count: 5,
          },
          {
            tag: 'forehand',
            doc_count: 4,
          },
          {
            tag: 'return',
            doc_count: 3,
          },
          {
            tag: 'overhead',
            doc_count: 3,
          },
          {
            tag: 'underhand',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'volleyball',
        doc_count: 22,
        tags: [
          {
            tag: 'serve',
            doc_count: 12,
          },
          {
            tag: 'spike',
            doc_count: 11,
          },
          {
            tag: 'jump',
            doc_count: 2,
          },
          {
            tag: 'dig',
            doc_count: 1,
          },
          {
            tag: 'set',
            doc_count: 1,
          },
          {
            tag: 'overhead',
            doc_count: 1,
          },
        ],
      },
    ],
  },
  {
    category: 'superpower',
    doc_count: 169,
    subcategories: [
      {
        subcategory: 'flying',
        doc_count: 66,
        tags: [
          {
            tag: 'hover',
            doc_count: 33,
          },
          {
            tag: 'glide',
            doc_count: 10,
          },
          {
            tag: 'take off',
            doc_count: 7,
          },
          {
            tag: 'land',
            doc_count: 9,
          },
          {
            tag: 'backwards',
            doc_count: 3,
          },
          {
            tag: 'power pose',
            doc_count: 2,
          },
          {
            tag: 'soar',
            doc_count: 1,
          },
          {
            tag: 'abduction',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'jumps and landings',
        doc_count: 33,
        tags: [],
      },
      // {
      //   subcategory: 'laser vision',
      //   doc_count: 1,
      //   tags: [],
      // },
      {
        subcategory: 'magic',
        doc_count: 40,
        tags: [
          {
            tag: 'cast spells',
            doc_count: 22,
          },
          {
            tag: 'incantation',
            doc_count: 15,
          },
          {
            tag: 'energy blast',
            doc_count: 10,
          },
          {
            tag: 'fireball',
            doc_count: 4,
          },
          {
            tag: 'wand',
            doc_count: 4,
          },
          {
            tag: 'levitate',
            doc_count: 1,
          },
          {
            tag: 'lightning',
            doc_count: 2,
          },
          {
            tag: 'hadouken',
            doc_count: 2,
          },
          {
            tag: 'summon',
            doc_count: 2,
          },
          {
            tag: 'healing',
            doc_count: 1,
          },
          {
            tag: 'air bend',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'power up',
        doc_count: 5,
        tags: [
          {
            tag: 'power stance',
            doc_count: 2,
          },
          {
            tag: 'transform',
            doc_count: 1,
          },
          {
            tag: 'activate power',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'superspeed',
        doc_count: 1,
        tags: [],
      },
      {
        subcategory: 'superstrength',
        doc_count: 23,
        tags: [
          {
            tag: 'slam',
            doc_count: 7,
          },
          {
            tag: 'throw',
            doc_count: 4,
          },
          {
            tag: 'lift',
            doc_count: 4,
          },
          {
            tag: 'jump',
            doc_count: 3,
          },
          {
            tag: 'push',
            doc_count: 2,
          },
          {
            tag: 'pull',
            doc_count: 1,
          },
          {
            tag: 'carry',
            doc_count: 1,
          },
        ],
      },
    ],
  },
  {
    category: 'tools',
    doc_count: 538,
    subcategories: [
      {
        subcategory: 'blunt',
        doc_count: 89,
        tags: [
          {
            tag: 'hammer',
            doc_count: 37,
          },
          {
            tag: 'sledgehammer',
            doc_count: 13,
          },
          {
            tag: 'shovel',
            doc_count: 17,
          },
          {
            tag: 'nails',
            doc_count: 3,
          },
          {
            tag: 'battering ram',
            doc_count: 1,
          },
          {
            tag: 'club',
            doc_count: 2,
          },
          {
            tag: 'bat',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'household',
        doc_count: 361,
        tags: [
          {
            tag: 'utensils',
            doc_count: 64,
          },
          {
            tag: 'cleaning',
            doc_count: 45,
          },
          {
            tag: 'appliances',
            doc_count: 21,
          },
          {
            tag: 'cooking utensils',
            doc_count: 17,
          },
          {
            tag: 'food prep',
            doc_count: 8,
          },
          {
            tag: 'gardening & outdoor',
            doc_count: 6,
          },
          {
            tag: 'arts and crafts',
            doc_count: 5,
          },
          {
            tag: 'writing',
            doc_count: 6,
          },
          {
            tag: 'furnishings & decor',
            doc_count: 5,
          },
          {
            tag: 'leisure',
            doc_count: 1,
          },
          {
            tag: 'electronics',
            doc_count: 2,
          },
          {
            tag: 'self care',
            doc_count: 2,
          },
          {
            tag: 'office work',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'mechanical',
        doc_count: 3,
        tags: [
          {
            tag: 'jackhammer',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'sharp',
        doc_count: 12,
        tags: [
          {
            tag: 'knife',
            doc_count: 6,
          },
          {
            tag: 'scissors',
            doc_count: 1,
          },
          {
            tag: 'needle',
            doc_count: 1,
          },
          {
            tag: 'saw',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'visual',
        doc_count: 67,
        tags: [
          {
            tag: 'binoculars',
            doc_count: 43,
          },
          {
            tag: 'telescope',
            doc_count: 16,
          },
          {
            tag: 'magnifying glass',
            doc_count: 1,
          },
          {
            tag: 'periscope',
            doc_count: 1,
          },
          {
            tag: 'spyglass',
            doc_count: 1,
          },
        ],
      },
    ],
  },
  {
    category: 'vehicles and transportation',
    doc_count: 53,
    subcategories: [
      // {
      //   subcategory: 'aircraft',
      //   doc_count: 1,
      //   tags: [],
      // },
      {
        subcategory: 'animals',
        doc_count: 7,
        tags: [
          {
            tag: 'saddle',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'bicycles',
        doc_count: 2,
        tags: [
          {
            tag: 'pedal',
            doc_count: 1,
          },
          {
            tag: 'balance',
            doc_count: 1,
          },
          {
            tag: 'wheelie',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'boats',
        doc_count: 2,
        tags: [
          {
            tag: 'paddle',
            doc_count: 1,
          },
          {
            tag: 'row',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'cars',
        doc_count: 22,
        tags: [
          {
            tag: 'drive',
            doc_count: 13,
          },
          {
            tag: 'change gears',
            doc_count: 4,
          },
          {
            tag: 'buckle seatbelt',
            doc_count: 1,
          },
          {
            tag: 'reverse',
            doc_count: 2,
          },
          {
            tag: 'accelerate',
            doc_count: 1,
          },
          {
            tag: 'drift',
            doc_count: 1,
          },
          {
            tag: 'crash',
            doc_count: 1,
          },
          {
            tag: 'honk',
            doc_count: 1,
          },
        ],
      },
      {
        subcategory: 'motorcycles',
        doc_count: 6,
        tags: [
          {
            tag: 'ride',
            doc_count: 4,
          },
          {
            tag: 'lean',
            doc_count: 4,
          },
          {
            tag: 'rev',
            doc_count: 2,
          },
        ],
      },
      {
        subcategory: 'public transit',
        doc_count: 10,
        tags: [
          {
            tag: 'hold handrail',
            doc_count: 3,
          },
          {
            tag: 'ride',
            doc_count: 5,
          },
          {
            tag: 'pull brake',
            doc_count: 1,
          },
          {
            tag: 'exit',
            doc_count: 1,
          },
        ],
      },
    ],
  },
];

// // Sort categories alphabetically by category name
// const sortedCategories = [...DEFAULT_BROWSE_CATEGORIES].sort((a, b) =>
//   a.category.localeCompare(b.category),
// );

// // For each category, sort its subcategories alphabetically by subcategory name
// sortedCategories.forEach((category) => {
//   category.subcategories.sort((a, b) =>
//     a.subcategory.localeCompare(b.subcategory),
//   );
// });

// // Export the sorted array
// export const SORTED_BROWSE_CATEGORIES = sortedCategories;

// console.log(JSON.stringify(SORTED_BROWSE_CATEGORIES, null, 2));
